<div
  class="nav-container full-width"
  [style]="{ 'background-color': navService.backgroundColor() }"
>
  <div class="nav">
    <a class="logo" href="/">
      <img
        ngSrc="/icons/Logo.svg"
        width="170"
        height="48"
        alt="Les Explorateurs du monde - Blog voyages belge"
        title="Les Explorateurs du monde - Blog voyages belge"
      />
    </a>
    @if (deviceService.isDesktop()) {
      <ng-template *ngTemplateOutlet="linksTemplate"> </ng-template>
    }
    <div class="nav-link" [class.mobile-margin]="deviceService.isMobileOrTablet()">
      <img alt="mglass" ngSrc="/icons/mglass.svg" width="16" height="17" (click)="openSearch()" />
    </div>
    @if (deviceService.isMobileOrTablet()) {
      <div
        class="hamburger hamburger--squeeze js-hamburger nav-link"
        (click)="showMenu()"
        [class.is-active]="showMobileMenu"
        type="button"
      >
        <span class="hamburger-box">
          <span class="hamburger-inner"></span>
        </span>
      </div>
    }
  </div>
</div>

@if (deviceService.isMobileOrTablet()) {
  <div class="mobile-nav" [@mobileLinksAnimation]="showMobileMenu ? 'showMenu' : 'hideMenu'">
    <div class="links-container">
      <ng-template *ngTemplateOutlet="linksTemplate"> </ng-template>
    </div>
  </div>
}

<ng-template #linksTemplate>
  <nav>
    <ul>
      <li
        class="link nav-link destinations"
        (mouseleave)="removeAnim()"
        (click)="showDestination()"
      >
        <div class="destination-link" [class.show-destination]="showMobileDestination">
          <a href="/destinations">Destinations</a>
          @if (deviceService.isMobileOrTablet()) {
            <span class="chevron">
              <img ngSrc="/icons/arrowDown.svg" width="18" height="18" />
            </span>
          }
        </div>
        @if (deviceService.isDesktop()) {
          <div class="pop-menu">
            <div class="links-container">
              <div
                class="link no-anim"
                *ngFor="let destination of destinations"
                (mouseenter)="hoverDestination(destination)"
                (mouseenter)="hovered($event)"
              >
                <a [href]="'/destination/' + destination.country">
                  {{ destination.country }}
                  <div class="line"></div>
                </a>
              </div>
            </div>
            <div class="picture-container" #container>
              <img alt="destinationPicture" [src]="hoveredDestination?.coverPicture?.src" />
            </div>
          </div>
        }
        @if (showMobileDestination && deviceService.isMobileOrTablet()) {
          <div class="links">
            <div class="link no-anim" *ngFor="let destination of destinations">
              <a [href]="'/destination/' + destination.country">
                {{ destination.country }}
                <div class="line"></div>
              </a>
            </div>
          </div>
        }
      </li>
      <li class="link nav-link sub-menu-link">
        <div
          class="mobile-link-wrapper"
          [class.show-submenu]="showMobileRoadtrip"
          (click)="toggleSubMenu('roadtrip', $event)"
        >
          <a href="/roadtrip"> Roadtrip </a>
          @if (deviceService.isMobileOrTablet()) {
            <span class="chevron">
              <img ngSrc="/icons/arrowDown.svg" width="18" height="18" />
            </span>
          }
        </div>
        <ul class="sub-menu" [class.open]="showMobileRoadtrip">
          @for (destination of destinations; track destination.id) {
            @if (roadTripArticles && roadTripArticles[destination.id]) {
              <li>
                <div class="link no-anim">
                  <a href="/roadtrip/{{ destination.country }}">
                    {{ destination.country }}
                    <div class="line"></div>
                  </a>
                </div>
              </li>
            }
          }
          @if (roadTripArticles && roadTripArticles['none']) {
            @for (article of roadTripArticles['none'].articles; track $index) {
              <li>
                <div class="link no-anim">
                  <a [href]="article.slug">
                    {{ article.name }}
                    <div class="line"></div>
                  </a>
                </div>
              </li>
            }
          }
        </ul>
      </li>
      <li class="link nav-link sub-menu-link">
        <div
          class="mobile-link-wrapper"
          [class.show-submenu]="showMobileBelgique"
          (click)="toggleSubMenu('belgique', $event)"
        >
          <a href="/destination/Belgique"> Belgique </a>
          @if (deviceService.isMobileOrTablet()) {
            <span class="chevron">
              <img ngSrc="/icons/arrowDown.svg" width="18" height="18" />
            </span>
          }
        </div>
        <ul class="sub-menu" [class.open]="showMobileBelgique">
          <li>
            <div class="link no-anim">
              <a href="/belgique/roadtrip">
                Road-trip
                <div class="line"></div>
              </a>
            </div>
          </li>
          <li>
            <div class="link no-anim">
              <a href="/belgique/citytrip">
                City-trip
                <div class="line"></div>
              </a>
            </div>
          </li>
          <li>
            <div class="link no-anim">
              <a href="/belgique/randonnees">
                Randonnées
                <div class="line"></div>
              </a>
            </div>
          </li>
        </ul>
      </li>
      <li class="link nav-link">
        <a href="/logements">
          Logements insolites
          <div class="line"></div>
        </a>
      </li>
      <li class="link nav-link">
        <a href="/ebooks/5-randonnees-belgique">
          Ebook
          <div class="line"></div>
        </a>
      </li>
      <li class="link nav-link">
        <a href="/contact">
          Contact
          <div class="line"></div>
        </a>
      </li>
    </ul>
  </nav>
</ng-template>

<span class="animation-container" [class.no-pointer-events]="search !== 'search'">
  <div [@searchAnimation]="search" class="search-container">
    <div class="container">
      <div class="cross" (click)="closeSearch()">
        <img ngSrc="/icons/close.svg" width="28" height="28" alt="close" />
      </div>
      <div class="search-box w-10" [class.has-results]="hasSearched">
        <input type="text" placeholder="Je cherche..." #searchInput />
      </div>
      <div
        class="results full-width"
        [class.display]="(searchResults && searchResults.length > 0) || searchMessage !== ''"
      >
        <div class="row full-width">
          @if (searchMessage !== '') {
            <div class="search-message full-width">
              {{ searchMessage }}
            </div>
          }
          <app-article-card
            *ngFor="let article of searchResults"
            [article]="article"
            class="w-4 search-article"
            [class.w-6]="deviceService.isTablet()"
            [class.w-12]="deviceService.isMobile()"
            (click)="closeSearch(false)"
            [showDescription]="false"
          >
          </app-article-card>
        </div>
      </div>
    </div>
  </div>
</span>
